<template>
  <div class="documents-tab">
    <template v-if="isMy">
      <div class="update-doc">
        <div class="content">
          <div class="text_large">{{ i18n.sale_tab_documents_ismy_header() }}</div>
          <div class="text_small text_description text_margin">{{ i18n.sale_tab_documents_ismy_text() }}</div>
          <div class="text_small text_description text_margin">{{ i18n.divid_save_report() }}</div>
          <div class="text_small text_description text_margin">{{ i18n.lbl_pdf_5mb() }}</div>
          <div class="text_small text_description text_margin">
            <file-field v-model="upload"
                        accept=".pdf"
                        :checkType="true"
                        id="documents-tab__file-field"/>
          </div>
        </div>
      </div>
      <md-button class="btn md-primary"
                 v-if="upload.file"
                 @click="submit"
                 :disabled="isPending">
        {{i18n.lbl_publish_file()}}
      </md-button>
    </template>

    <template v-else-if="!documents.length && !isMy">
      <div class="empty-timeline-message">
        <div class="text_large">{{i18n.sale_doc_tab_docs_is_my()}}</div>
      </div>
    </template>

    <div class="documents-tab__docs-list" v-if="documents.length">
      <template v-for="(document, i) in documents">
        <div class="documents-tab__file-download-wrp" :key="i">
          <h3 class="file-download__file-name" :title="document.name">{{ document.name }}</h3>
          <a :href="getUrl(document)" class="file-view__link" target="_blank" rel="noopener">
            <span>{{i18n.fi_view_file()}}</span>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import SubmitterMixin from '@com/mixins/submitter.mixin'
  import FileField from '@com/fields/FileField'
  import { i18n } from '@js/i18n'

  import { ErrorHandler } from '@js/errors/error_handler'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { confirmAction } from '@js/modals/confirmation_message'
  import { blobTypes, blobFilters } from '@const'
  import { fileService } from '@api/file.service'
  import { usersService } from '@api/users.service'
  import { DocumentContainer } from '@js/helpers/DocumentContainer'
  import _get from 'lodash/get'
  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { commonEvents } from '@js/events/common_events'

  export default {
    name: 'documents-tab',

    components: {
      FileField
    },
    props: ['sale'],

    mixins: [SubmitterMixin],

    data: _ => ({
      i18n,
      documents: [],
      upload: {
        mimeType: '',
        file: '',
        name: ''
      }
    }),

    computed: {
      ...mapGetters([
        vuexTypes.accountId
      ]),
      isMy () {
        return this.sale.owner === this.accountId
      }
    },

    methods: {
      async submit () {
        if (!await confirmAction({
          title: i18n.sale_confirm_upload_ttl(),
          message: i18n.sale_confirm_upload()
        })) return
        const tokenCode = this.sale.baseAsset
        this.disable()
        try {
          this.upload.type = blobTypes.fundDocument.str
          const fileKey = await fileService.uploadFile(this.upload.getDetailsForUpload())
          this.upload.setKey(fileKey)
          await usersService.blobsOf(this.sale.owner).create(
            blobTypes.fundDocument.str,
            {
              type: this.upload.mimeType,
              name: this.upload.name,
              key: fileKey
            },
            { [blobFilters.tokenCode]: tokenCode }
          )
          EventDispatcher.dispatchShowSuccessEvent(i18n.sale_upload_success())
          await this.getDocuments()
          this.reset()
        } catch (error) {
          console.error(error)
          ErrorHandler.processUnexpected(error)
        }
        this.enable()
      },
      async getDocuments () {
        if (!_get(this.sale, 'baseAsset')) return
        this.documents = (await usersService
          .blobsOf(this.sale.owner)
          .getAll({
            [blobFilters.tokenCode]: this.sale.baseAsset,
            [blobFilters.type]: blobTypes.fundDocument.num
          }))
          .map(doc => new DocumentContainer(doc))
        this.$emit(commonEvents.isFundDocumentsUploaded, this.documents)
        console.log(this.documents)
      },
      reset () {
        this.upload.file = ''
        this.upload.mimeType = ''
      },
      getUrl (file) {
        return file.publicUrl
      }
    },
    watch: {
      sale: {
        handler: 'getDocuments',
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  /*.update-doc {
    display: flex;
    justify-content: center;
    align-content: center;
    background: linear-gradient(0deg, rgba(203, 226, 230, 0.1), rgba(203, 226, 230, 0.1)), #FFFFFF;
    border: 1px dashed rgba(203, 226, 230, 0.8);
    box-sizing: border-box;
    border-radius: 5px;
    padding: 50px 0;
    .content {
      width: 380px;
      text-align: center;
      .file-field__outer {
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
      }
      .documents-tab__file-desc {
        padding: 15px 0;
        color: $col-text-secondary;
      }
    }
  }*/

  /*.documents-tab__file-submit {
    margin: 40px 0 30px;
    & /deep/ .md-button-content {
      font-size: 20px;
    }
  }


  .documents-tab__no-docs-message {
    text-align: center;
  }

  .documents-tab__file-input {
    margin-top: 30px;
    text-align: center;
  }

  .documents-tab__explain {
    color: $blue;
    text-align: center;
  }

  .documents-tab__docs-list {
    margin: 40px auto;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .documents-tab__file-download-wrp {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    width: 50%;
  }

  .file-download {
    display: flex;
    flex-direction: column;
  }

  .file-view__link {
    color: $col-active;
    cursor: pointer;
    display: flex;
    text-decoration: underline;
    i {
      color: $col-active;
      margin-left: 5px;
    }
  }

  .file-download__file-name {
    max-width: 180px;
    overflow: hidden;
    margin-right: 0.5rem;
    text-overflow: ellipsis;
  }

  .no-data-msg__wrapper {
    display: flex;
    flex-direction: column;
    text-align: center;
    color: $col-text-secondary;
  }*/
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/tabs/Sales.DocumentsTab.vue